<template>
  <div class="box4-container">
    <div class="gas_list">
      <ul>
        <li v-for="(item,index) in gasData.slice(0,9)" :key="index">
          <div class="pad">
            <div class="icon"><img :src="getImageSrc(index)" class="img" /></div>
            <div class="text">
              <div class="value">{{item.value}}<em v-if="item.unit">{{item.unit}}</em></div>
              <div class="name">{{item.name}}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>   
</template>

<script>
export default {
  name: 'Box4', 
  props: {
    itemData: {
      type: Array,
      required: true,
      default: function () {
        return [ ]
      }
    },
  },
  data() {
    return {
      gasData:[
        {
          name: this.$t("home.box4.text1"),
          unit: '°C',
          value: 0
        },
        {
          name: this.$t("home.box4.text2"),
          unit: 'RH%',
          value: 0
        },
        {
          name: 'PM2.5',
          unit: 'μg/m3',
          value: 0
        },
        {
          name: 'PM10',
          unit: 'μg/m3',
          value: 0
        },
        {
          name: this.$t("home.box4.text3"),
          unit: 'lux',
          value: 0
        },
        {
          name: this.$t("home.box4.text4"),
          unit: 'm/s',
          value: 0
        },
        {
          name: this.$t("home.box4.text5"),
          unit: '',
          value: ''
        },
        {
          name: this.$t("home.box4.text6"),
          unit: 'db',
          value: 0
        },
        {
          name: this.$t("home.box4.text7"),
          unit: 'kPa',
          value: 0
        }
      ]
    }
  },
  watch: {
    itemData: function(newVal){
      if(newVal.length>0){
        this.gasData = newVal;
      }
    }
  },
  methods: {
    getImageSrc(index) {
      return require(`@/assets/home_images/box4/icon${index}.png`);
    }
  }
}
</script>
<style lang='less'>
.box4-container {
  width: 100%;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  padding:0 30px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  .gas_list {
    width: 100%;
    height:100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    ul{
      width: 100%;
      height:100%;
      padding: 0;
      margin: 0;
      list-style: none;
      display: flex;
      flex-wrap: wrap; 
      li{
        width: 33.33%; 
        position: relative;
        .pad{
          padding: 5px;
          display: flex;
          align-items: center;
        }
        .icon{
          width: 50px;
          height: 50px;
          margin-right: 8px;
          background-position: center center;
          background-repeat: no-repeat;
          background-image: url(../../assets/home_images/box4/air-item-bg.png);
          background-size: 100% 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          .img{
            width: 24px;
            height: auto;
          }
        }
        .text{
          .value{
            color: #17b5ff;
            font-size: 20px;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            em{
              margin-left: 5px;
              font-size: 11px;
              color:#fff;
              font-style: normal;
              font-family: Arial;
              font-weight: normal;
            }
          }
          .name{
            color:#fff;
            font-size: 12px;
            margin-top: 5px;
          }
        }
      }
    }
  }
}
</style>
